
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/validators",
      function () {
        return require("private-next-pages/validators/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/validators"])
      });
    }
  